import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Modal,Navbar,Table} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import uuid from 'react-uuid'

export default function Finish() {

    const {accountingData,setAccountingData}=useContext(UserContext)
    const {catalogueData,setCatalogueData}=useContext(UserContext)
    const {activeTab,setActiveTab}=useContext(UserContext)
    const {exhibition,setExhibition}=useContext(UserContext)
    const [show,setShow]=useState(false)
    const {exhibitionExhibits,setExhibitionExhibits}=useContext(UserContext)
    const {oikoi,setOikoi}=useContext(UserContext)
    const {items,setItems}=useContext(UserContext)
    const [itemsLocal,setItemsLocal]=useState([])
    const [grandTotal,setGrandTotal]=useState(0)
    const [regObj,setRegObj]=useState({})
    const {sendForm}=useContext(UserContext)
    const [isSaving,setIsSaving]=useState(false)

    useEffect(()=>{
      //console.log(exhibition)

    },[activeTab,exhibition])




    const itemsList=items.filter(xitem=>xitem.quantity>0).map(item=>{
            return(
                <tr>
                    <td>{item.GXDESCRIPTION} // {item.GXDESCRIPTIONENG}</td>
                    <td align="right">{item.PRICE}</td>
                    <td align="center">{item.Unit}</td>
                    <td width="10%">{item.quantity}</td>
                    <td align="right">{item.totalPrice.toFixed(2)}</td>
                </tr>
            )

       
    })

    const exhibitionExhibitsList=exhibitionExhibits.filter(item=>item.Checked==1).map(exhibit=>{
        return(
        <>
        <Card key={exhibit.ETA30CODE}>
        <Card.Body>
            <Card.Text>
            {exhibit.ETA30CODE} // {exhibit.ETA30DESCRIPTION} // {exhibit.ETA30ALTDESCRIPTION}
             </Card.Text>
        </Card.Body>
        </Card>
        <br/>
        </>
        )

    })

    const firmsList=oikoi.map((item,index)=>{
        return(
            <>
            <Card key={item.CMID}>
            <Card.Body>
             <Card.Title>{item.USKATALOGOSONOMAOIKOUELL} // {item.USKATALOGOSONOMAOIKOUENG}</Card.Title>
            <Card.Text>
            {item.USKATALOGOSOIKOXORA} // {item.USKATALOGOSOIKOSXORAENG}<br/>
            {item.USKATALOGOSOIKOEMAIL}

            </Card.Text>
            </Card.Body>
            </Card>
            <br/>
            </>

        )
    })

  return (
    <Container fluid>
    <>
    <Alert variant='success'>
      <h4>ΠΡΟΕΠΙΣΚΟΠΙΣΗ KAI OΛΟΚΛΗΡΩΣΗ ΕΓΓΡΑΦΗΣ // PREVIEW AND FINISH REGISTRATION</h4>
    </Alert>
    </>


    <Alert variant="warning">ΣΤΟΙΧΕΙΑ ΤΙΜΟΛΟΓΗΣΗΣ // ACCOUNTING DETAILS</Alert>

        <Table striped bordered hover>

        <tbody>
        <tr>
            <td width="40%"><b>ΕΠΩΝΥΜΙΑ ΕΤΑΙΡΙΑΣ // COMPANY NAME:</b></td>
            <td>{accountingData.CMNAME}</td>
        </tr>
        <tr>
            <td><b>ΑΦΜ // VAT NUMBER:</b></td>
            <td>{accountingData.CMTIN}</td>
        </tr>
        <tr>
            <td><b>ΔΟΥ // TAX OFFICE:</b></td>
            <td>{accountingData.DOY}</td>
        </tr>
        <tr>
            <td><b>ΕΠΑΓΓΕΛΜΑTIKH ΔΡΑΣΤΗΡΙΟΤΗΤΑ // PROFESIONAL SECTOR:</b></td>
            <td>{accountingData.PROFESSION}</td>
        </tr>
        <tr>
            <td><b>ΧΩΡΑ // COUNTRY:</b></td>
            <td>{accountingData.COUNTRY}</td>
        </tr>
        <tr>
            <td><b>ΔΙΕΥΘΥΝΣΗ // ADDRESS:</b></td>
            <td>{accountingData.STREET} {accountingData.CMSTREETNUMBER}</td>
        </tr>
        <tr>
            <td><b>ΠΟΛΗ // CITY:</b></td>
            <td>{accountingData.CITY}</td>
        </tr>
        <tr>
            <td><b>TK // POSTAL CODE:</b></td>
            <td>{accountingData.CMPOSTALCODE}</td>
        </tr>
        <tr>
            <td><b>EMAIL:</b></td>
            <td>{accountingData.CMEMAIL}</td>
        </tr>
        <tr>
            <td><b>ΤΗΛΕΦΩΝΟ // TELEPHONE:</b></td>
            <td>{accountingData.CMPHONE1}</td>
        </tr>
        <tr>
            <td><b>ΓΕΜΗ:</b></td>
            <td>{accountingData.GEMI}</td>
        </tr>
        {exhibition.NeedEpimList==1 &&
        <tr>
            <td><b>ΕΠΙΜΕΛΗΤΗΡΙΟ:</b></td>
            <td>{accountingData.Epimel}</td>
        </tr>
        }

        {exhibition.HasRetail==1 &&
        <tr>
            <td><b>ΛΙΑΝΙΚΕΣ ΠΩΛΗΣΕΙΣ:</b></td>
            <td>{accountingData.lp==1 ? 'NAI' : 'OXI'}</td>
        </tr>
        }

        </tbody>

    </Table>

    <Alert variant="warning">ΣΤΟΙΧΕΙΑ ΚΑΤΑΛΟΓΟΥ // CATALOGUE DETAILS</Alert>

    <Table striped bordered hover>

        <tbody>
        <tr>
            <td width="40%"><b>ΕΠΩΝΥΜΙΑ (ΓΙΑ ΤΟΝ ΚΑΤΑΛΟΓΟ ΣΤΑ ΕΛΛΗΝΙΚΑ):</b></td>
            <td>{catalogueData.CMSTRINGFIELD2}</td>
        </tr>

        <tr>
            <td><b>COMPANY NAME (FOR CATALOGUE IN ENGLISH):</b></td>
            <td>{catalogueData.CMSTRINGFIELD3}</td>
        </tr>
        <tr>
            <td><b>ΕΠΩΝΥΜΙΑ ΜΕΤΩΠΗΣ // NAME BOARD (for type 2/3 stands):</b></td>
            <td>{catalogueData.CMSTRINGFIELD4}</td>
        </tr>
        <tr>
            <td><b>ΟΔΟΣ:</b></td>
            <td>{catalogueData.USKATALOGOSODOS} {catalogueData.USKATALOGOSARITHMOS}</td>
        </tr> 
        <tr>
            <td><b>STREET ADDRESS:</b></td>
            <td>{catalogueData.USKATALOGOSODOSENG} {catalogueData.USKATALOGOSARITHMOS}</td>
        </tr>         
        <tr>
            <td><b>ΤΑΧ.ΚΩΔΙΚΑΣ // POSTAL CODE:</b></td>
            <td>{catalogueData.USKATALOGOSTK}</td>
        </tr> 
        <tr>
            <td><b>ΠΟΛΗ:</b></td>
            <td>{catalogueData.USKATALOGOSPOLI}</td>
        </tr> 
        <tr>
            <td><b>CITY:</b></td>
            <td>{catalogueData.USKATALOGOSPOLIENG}</td>
        </tr>         
        <tr>
            <td><b>ΝΟΜΟΣ:</b></td>
            <td>{catalogueData.USKATALOGOSNOMOS}</td>
        </tr> 
        <tr>
            <td><b>REGION:</b></td>
            <td>{catalogueData.USKATALOGOSNOMOSENG}</td>
        </tr>  

        <tr>
            <td><b>ΧΩΡΑ:</b></td>
            <td>{catalogueData.USKATALOGOSXORA}</td>
        </tr> 
        <tr>
            <td><b>COUNTRY:</b></td>
            <td>{catalogueData.USKATALOGOSXORAENG}</td>
        </tr>     
        <tr>
            <td><b>ΤΗΛΕΦΩΝΟ 1 // TELEPHONE 1:</b></td>
            <td>{catalogueData.USKATALOGOS1THL}</td>
        </tr>  
        <tr>
            <td><b>ΤΗΛΕΦΩΝΟ 1 // TELEPHONE 2:</b></td>
            <td>{catalogueData.USKATALOGOS2THL}</td>
        </tr> 
        <tr>
            <td><b>EMAIL:</b></td>
            <td>{catalogueData.USKATALOGOSEMAIL}</td>
        </tr> 
        <tr>
            <td><b>WEB SITE:</b></td>
            <td>{catalogueData.USKATALOGOSWEBSITE}</td>
        </tr> 
        <tr>
            <td><b>ΥΠΕΥΘΥΝΟΣ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON:</b></td>
            <td>{catalogueData.USYPEYTHINOSSYMMETOXIS}</td>
        </tr> 

        <tr>
            <td><b>ΥΠΕΥΘΥΝΟΣ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON:</b></td>
            <td>{catalogueData.USPHONEYPEYTHINOU}</td>
        </tr> 
        <tr>
            <td><b>ΥΠΕΥΘΥΝΟΣ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON:</b></td>
            <td>{catalogueData.USEMAILYPEUTHINOU}</td>
        </tr> 

        <tr>
            <td><b>ΣΥΝΤΟΜΟ ΠΡΟΦΙΛ:</b></td>
            <td>{catalogueData.PROFILEGR}</td>
        </tr> 
        <tr>
            <td><b>SHORT PROFILE:</b></td>
            <td>{catalogueData.PROFILEENG}</td>
        </tr> 


        </tbody>
    </Table>


    {exhibition.XP==1 &&
    <>
    <Alert variant="warning">ΣΤΟΙΧΕΙΑ ΥΠΕΥΘΥΝΟΥ B2B // B2B CONTACT DETAILS</Alert>
    <Table striped bordered hover>

        <tbody>
        <tr>
            <td width="40%"><b>ΥΠΕΥΘΥΝΟΣ ΣΥΜΜΕΤΟΧΗΣ B2B// B2B CONTACT PERSON:</b></td>
            <td>{catalogueData.xpname}</td>
        </tr> 

        <tr>
            <td><b>ΤΗΛΕΦΩΝΟ ΥΠΕΥΘΥΝΟΥ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON TELEPHONE:</b></td>
            <td>{catalogueData.xpphone}</td>
        </tr> 
        <tr>
            <td><b>ΕΜΑΙL ΥΠΕΥΘΥΝΟΥ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON ΕΜΑΙL:</b></td>
            <td>{catalogueData.xpemail}</td>
        </tr> 
        </tbody>
    </Table>    
    </>
    }

    <Alert variant="warning">OIKOI // FIRMS</Alert>
    {firmsList}
    <Alert variant="warning">ΕΚΘΕΜΑΤΑ // EXHIBITS</Alert>
    {exhibitionExhibitsList}
    <Alert variant="warning">ΧΡΕΩΣΕΙΣ  // ACCOUNTING DETAILS</Alert>
    <hr/>
    <b>Προτιμώμενο Περίπτερο // Preferred Pavilion:</b> {catalogueData.Pav}
    <hr/>
    <h4>{exhibition.Notes}</h4>
    <hr/>
    <Table striped bordered hover>
                <thead>
                    <tr>
                    <th></th>
                    <th>Τιμή Μονάδας/Unit Price (€)</th>
                    <th>Μονάδα Μέτρησης/Unit of Measure</th>
                    <th>Ποσότητα/Quantity</th>
                    <th>Σύνολο/Total (€)</th>
                    </tr>
                </thead>
                <tbody>
                    {itemsList}
                </tbody>
            </Table>

            <p align="center">
            <hr/>
                <Button disabled={isSaving} onClick={()=>{setIsSaving(true);sendForm(0)}} style={{width:'30vw',height:'5vh',fontWeight:"bolder"}} variant="success">ΟΛΟΚΛΗΡΩΣΗ // FINISH REGISTRATION</Button>
            <hr/>
            </p>
    <>
    <br/><br/><br/><br/>
    <Navbar bg="light" fixed="bottom" >
        <table width="100%"><tbody><tr>
                  
                  <td align="left">
                    {accountingData.CMTIN && 
                      <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
                    }
                
  
              </td>  <td align="right">
        <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('stands')}}>ΠΙΣΩ // BACK</Button>
        </td></tr></tbody></table>
    </Navbar> 
    </>

    </Container>
  )
}
